import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { Charge } from './charge.entity';
import { ChargeStatus } from './charge.status.enum';
export class CreateChargeDto extends Omit(Charge, [...BaseEntityFieldsArray, 'status'], ['status']) {
    status?: ChargeStatus;
}
